import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types/image';
import { classNames } from '@repo/ui/src/utils/classNames';
import Image from 'next/image';

interface Props {
  image?: ImageProps;
  aspectWidth?: number;
  aspectHeight?: number;
  imageWidth: number;
  display: boolean;
}

const OverlayImage = ({ display, image, imageWidth, aspectWidth, aspectHeight }: Props) => {
  const imageUrl = buildImageSrc(image, imageWidth, aspectWidth, aspectHeight);

  return (
    <Image
      className={classNames(
        'absolute h-full w-full object-contain transition-opacity transition-500 ease-linear pointer-events-none',
        display ? 'opacity-100' : 'opacity-0',
      )}
      src={imageUrl}
      fill
      alt={image?.altTag || 'Product Overlay Image'}
    />
  );
};

export default OverlayImage;
